import {Component, OnInit} from '@angular/core';
import {ApplicantDetailsComponent} from '../../../shared/components/applicant-details/applicant-details.component';
import {AddressDetailsComponent} from '../../../shared/components/address-details/address-details.component';
import {IppaymentComponent} from '../../../shared/components/ippayment/ippayment.component';
import {LoginService} from '../../../shared/services/login.service';
import {FeeService} from '../../../shared/services/fee.service';
import {SERVICE_PROVIDER} from '../../../shared/services/fee.service';
import {SdaiService} from '../sdai.service';
import {Router} from '@angular/router';
import {FormControl, Validators} from '@angular/forms';
import {Steps} from 'primeng/primeng';
import * as MenuUtils from '../../../shared/data-objects/menu-item-ex';
import {ApplicationFormBase} from '../../../shared/data-objects/application-form-base';
import {IppaymentService} from '../../../shared/services/ippayment.service';
import { AddressService } from '../../../shared/services/address.service';
import {Sdai} from '../sdai';
import {Meta} from '@angular/platform-browser';

const referenceNumberRE = /^[a-zA-Z0-9\-\/\.\:]+$/;

Steps.prototype.itemClick = MenuUtils.itemClick;

@Component({
  selector: 'app-sdai',
  templateUrl: 'sdai.component.html',
  styleUrls: ['sdai.component.css'],
  entryComponents: [ApplicantDetailsComponent, AddressDetailsComponent, IppaymentComponent]
})

export class SDAIComponent extends ApplicationFormBase<Sdai> implements OnInit {
  isRequesting: boolean;
  SEWDrequiredControl: FormControl;
  ASSPrequiredControl: FormControl;

  refNumControl: FormControl;
  refNumControlLength = 11;
  pricingZone: string = SERVICE_PROVIDER.CWW;
  cwwPricingZone: boolean = true;

  constructor(protected loginService: LoginService, private feeService: FeeService, private addressService: AddressService,
              private sdaiService: SdaiService, protected ipPaymentService: IppaymentService, protected router: Router, private meta: Meta) {
    super(sdaiService, loginService, ipPaymentService, router);
    this.refNumControl = new FormControl('', [Validators.maxLength(this.refNumControlLength), Validators.pattern(referenceNumberRE)]);
    this.ASSPrequiredControl = new FormControl({value: false, disabled: false});
    this.SEWDrequiredControl = new FormControl({value: false, disabled: false});
    this.ipPaymentService.paymentformIsInit.subscribe((data: any) => {
      this.paymentformIsInit(4, this._totalOrderAmount);
    });
    this.meta.updateTag({ name: 'description', content: 'Apply for information regarding sewer and/or water mains. This does not cover plans for internal pipes on your property.' });
    
    // fetch pricing zone (CWW / WW)
    this.addressService.getPricingZone().subscribe(_pricingzone => {
      this.pricingZone = _pricingzone.toUpperCase() === SERVICE_PROVIDER.WW ? SERVICE_PROVIDER.WW : SERVICE_PROVIDER.CWW;
      this.cwwPricingZone = this.pricingZone === SERVICE_PROVIDER.CWW;
      console.log('PrizeZone:', this.pricingZone);
    }, err => {
      this.pricingZone = SERVICE_PROVIDER.CWW;
    });
  }

  async ngOnInit() {
    let isTokenValid = await this.loginService.isTokenValid();
    if(!isTokenValid) {
      if(this.loginService.isGuestUserLoggedIn()) {
        this.loginService.guestLogin((ok: boolean)=>{
          this.retrieveFees();
          this.setupTabs();
        });
      } else {
        this.router.navigate(['/login']);
      }
    } else {
      await this.loginService.refreshToken();
      this.retrieveFees();
      this.setupTabs();
      this.sdaiService.workrequestDetails.sewerDetails = true;
    }
  }

  retrieveFees(): void {
    this.feeService.retrieveFees('SimplePlumbing', this.loginService.getToken(), this.retrieveFeesOkCb.bind(this));
  }

  setupTabs(): void {
    // if (!this.loginService.isGuestUserLoggedIn()) {
    if (this.loginService.isUserBillLater()) {
      this.setApplicantDetailsForBillLater(this.sdaiService.applicationData.applicant);
      this.addMenuItem('Location details', this, 0, 'First Step');
      this.addMenuItem('Work request', this, 1, 'Second Step');
      this.addMenuItem('Applicant details', this, 2, 'Third Step');
      this.addMenuItem('Review and submit', this, 3, 'Fourth Step');
    } else {
      // this.setApplicantDetailsForGuestUser(this.sdaiService.applicationData.applicant);
      this.setApplicantDetailsForNonBillLater(this.sdaiService.applicationData.applicant);
      this.addMenuItem('Location details', this, 0, 'First Step');
      this.addMenuItem('Work request', this, 1, 'Second Step');
      this.addMenuItem('Applicant details', this, 2, 'Third Step');
      this.addMenuItem('Review and submit', this, 3, 'Fourth Step');
      this.addMenuItem('Payment', this, 4, 'Fifth Step');
    }
  }

  retrieveFeesOkCb(ok: boolean): void {
    if (ok) {
      this.sdaiService.SEWDFeeAmount = this.feeService.getSEWDFeeAmount(this.pricingZone);
      this.sdaiService.ASSPFeeAmount = this.feeService.getASSPFeeAmount(this.pricingZone);
      this.sdaiService.workrequestDetails.totalOrderAmount = this.sdaiService.SEWDFeeAmount;
      this.sdai.workrequestDetails = this.sdaiService.workrequestDetails;
    } else {
      console.log('no fees found');
    }
  }

  get totalOrderAmount(): number {
    return this.sdaiService.workrequestDetails.totalOrderAmount;
  };

  get SEWDrequired(): boolean {
    return this.sdaiService.workrequestDetails.sewerDetails;
  };

  set SEWDrequired(v: boolean) {
    this.sdaiService.workrequestDetails.sewerDetails = v;
    this.sdai.workrequestDetails.sewerDetails = v;
    this.sdaiService.workrequestDetails.totalOrderAmount = (this.SEWDrequired ? this.sdaiService.SEWDFeeAmount : 0) +
      (this.ASSPrequired ? this.sdaiService.ASSPFeeAmount : 0);
    //this.sdaiService.workrequestDetails.totalOrderAmount = this.SEWDrequired ? this.sdaiService.SEWDFeeAmount : 0;
  };

  get ASSPrequired(): boolean {
    return this.sdaiService.workrequestDetails.assetInfo;
  };

  set ASSPrequired(v: boolean) {
    this.sdaiService.workrequestDetails.assetInfo = v;
    this.sdai.workrequestDetails.assetInfo = v;
    this.sdaiService.workrequestDetails.totalOrderAmount = (this.SEWDrequired ? this.sdaiService.SEWDFeeAmount : 0) +
      (this.ASSPrequired ? this.sdaiService.ASSPFeeAmount : 0);
  };

  getTotalOrderAmount(): number {
    return this._totalOrderAmount;
  }

  get commitDisabled(): boolean {
  return ((!this.SEWDrequired && !this.ASSPrequired) ||
  //return (!this.SEWDrequired ||
      !this.sdaiService.agreedToTsAndCs ||
      this.applicant.invalid ||
      this.location.invalid ||
      this.refNumControl.invalid
    );
  }

  get sdai(): Sdai {
    return (this.sdaiService.applicationData) as Sdai;
  }

  get applicationDate(): string {
    return this.sdaiService.applicationDate;
  }

  set applicationDate(v: string) {
    this.sdaiService.applicationDate = v;
  }

  set submitErrorMessageWorkRequest(v: string) {
    this.sdaiService.submitErrorMessageWorkRequest = v;
  }

  get submitErrorMessageWorkRequest(): string {
    return this.sdaiService.submitErrorMessageWorkRequest;
  }

  get SEWDFeeAmount(): number {
    return this.sdaiService.SEWDFeeAmount;
  }

  set SEWDFeeAmount(v: number) {
    this.sdaiService.SEWDFeeAmount = v;
  }

  get ASSPFeeAmount(): number {
    return this.sdaiService.ASSPFeeAmount;
  }

  set ASSPFeeAmount(v: number) {
    this.sdaiService.ASSPFeeAmount = v;
  }

  get _isSEWDrequired(): boolean {
    return this.sdaiService.workrequestDetails.sewerDetails;
  }

  set _isSEWDrequired(v: boolean) {
    this.sdaiService.workrequestDetails.sewerDetails = v;
  }

  get _isASSPrequired(): boolean {
    return this.sdaiService.workrequestDetails.assetInfo;
  }

  set _isASSPrequired(v: boolean) {
    this.sdaiService.workrequestDetails.assetInfo = v;
  }

  get _totalOrderAmount(): number {
    return this.sdaiService.workrequestDetails.totalOrderAmount;
  }

  set _totalOrderAmount(v: number) {
    this.sdaiService.workrequestDetails.totalOrderAmount = v;
  }

  canGoNext(executeYes: any, executeNo: any): void {
    this.sdaiService.submitErrorMessage = '';

    if (this.activeIndex === 0) {
      this.navigateFromLocation(executeYes, executeNo);
    } else if (this.activeIndex === 1) {
      this.submitErrorMessageWorkRequest = '';
      if (!this.SEWDrequired && !this.ASSPrequired) {
      //if (!this.SEWDrequired) {
        this.submitErrorMessageWorkRequest = 'Please select at least one work request option';
        executeNo();
        return;
      } else {
        executeYes();
        return;
      }
    } else if (this.activeIndex === 2) {
      if (this.applicant.invalid && this.applicant.displayErrorMessage().length > 0) {
        this.sdaiService.submitErrorMessage += this.applicant.displayErrorMessage();
        executeNo();
        return;
      }

      this.validTermsAndConditions(executeNo, executeYes);
    // } else if (this.isGuestUserLoggedIn && this.activeIndex === 3) {
    } else if (!this.loginService.isUserBillLater() && this.activeIndex === 3) {
      // this.navigateToPaymentWhenGuestUser(executeYes, executeNo, this._totalOrderAmount, this.submitApplication.bind(this));
      this.navigateToPaymentWhenNonBillLaterUser(executeYes, executeNo, this._totalOrderAmount, this.submitApplication.bind(this));
    } else {
      executeYes();
    }
  }

  canGoPrevious(): boolean {
    // if (this.isGuestUserLoggedIn && (this.activeIndex === 0 || this.activeIndex === 4)) {
    if (!this.loginService.isUserBillLater() && (this.activeIndex === 0 || this.activeIndex === 4)) {
      return false;
    }

    // if (!this.isGuestUserLoggedIn && this.activeIndex === 0) {
    if (this.loginService.isUserBillLater() && this.activeIndex === 0) {
      return false;
    }

    return true;
  }

  goNext(): void {
    // if ((!this.isGuestUserLoggedIn && this.activeIndex === 3) || (this.isGuestUserLoggedIn && this.activeIndex === 4)) {
    if ((this.loginService.isUserBillLater() && this.activeIndex === 3) || (!this.loginService.isUserBillLater() && this.activeIndex === 4)) {
      return;
    }

    this.canGoNext(() => {
      this.activeIndex++;
    }, () => {
    });
  }

  goPrevious(): void {
    if (!this.canGoPrevious()) {
      return;
    }

    this.activeIndex--;
  }

  submitApplication(callback: any): void {
    if (this.commitDisabled) {
      this.sdaiService.submitErrorMessage = 'Please enter required information before submitting the application.';
      return;
    }
    if (!this.sdaiService.agreedToTsAndCs) {
      this.sdaiService.submitErrorMessage = 'Please select Terms and Conditions before submitting the application.';
      return;
    }
    this.setApplicantData();
    this.sdaiService.applicationData.locationAddress = this.location.addressDetails.locationAddress;
    this.sdaiService.applicationData.toUpperCase();

    this.doSubmit(callback);
  }

  newApplication(): void {
    window.location.reload();
    //super.newApplication();
    //this.SEWDrequiredControl.markAsUntouched();
    //this.ASSPrequiredControl.markAsUntouched();
    //this.refNumControl.markAsUntouched();
    //this.feeService.retrieveFees('SimplePlumbing', this.loginService.getToken(), this.retrieveFeesOkCb.bind(this));
  }

  private doSubmit(callback): void {
    this.executeSubmit('sdai', callback, this._totalOrderAmount, null, true);
  }
}



// WEBPACK FOOTER //
// ./src/app/create-application/sdai-form/sdai/sdai.component.ts